import copy from 'copy-to-clipboard';

import { Toast } from '@whelk/components';
import { isNative } from '@whelk/const/src/env';
import { isMiniProgram } from '@whelk/utils';

import { nativeBridge } from './bridge/callNativeBridge';
import i18n, { getTextByLang } from './i18n';
export const openUrl = (url: string, needSchema = true, target?: string) => {
  console.log('openUrl', url, needSchema, target);
  if (isNative) {
    nativeBridge.callNative({
      methodName: 'jumpPage',
      params: {
        openUrl: needSchema ? `yingshi://web?url=${url}` : url,
      },
    });
  } else if (isMiniProgram) {
    copy(url);
    Toast.show(getTextByLang('toast_redirect_url_copied', i18n.language));
  } else window.open(url, target);
};
